import React from 'react';

import {
  EXPERIMENT_NAMES,
  Experiment,
  Variant,
} from 'src/components/Experiment';
import styled from 'styled-components';
import FlightClassSwitcher from '..';

import FlightsProgressbar from '../../../components/Flights/FlightsProgressbar';

import FlightsLoadingResults from './components';
import { FLIGHT_LIST_ID } from './constants';
import LuggageFilterPanelComponent from '../../../components/LuggageFilterPanel';
import type { LoadingState } from '../../../store/flights/types';
import CheckoutBannersLoader from '../../../components/Flights/CheckoutBannersLoader';

interface FlightsListProps {
  loadingState: LoadingState;
  flightsCount: number;
  isMobile: boolean;
  archivedAt?: string | null;
}

export class FlightsList extends React.PureComponent<FlightsListProps> {
  render() {
    const { loadingState, flightsCount, isMobile, archivedAt } = this.props;
    const hasResults = flightsCount > 0;

    return (
      <div>
        {hasResults && <FlightClassSwitcher />}
        {!archivedAt && (
          <Experiment name={EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES.NAME}>
            <Variant
              option={EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES.OPTIONS.ON}
            >
              <FlightsProgressbar />
            </Variant>
          </Experiment>
        )}
        <LuggageFilterPanel />
        <CheckoutBannersLoader />
        <FlightsLoadingResults
          loadingState={loadingState}
          id={FLIGHT_LIST_ID}
          isMobile={isMobile}
        />
      </div>
    );
  }
}

const LuggageFilterPanel = styled(LuggageFilterPanelComponent)`
  margin-bottom: 16px;
`;
